<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="제목" prop="wr_subject">
              <el-input v-model="ruleForm.wr_subject"></el-input>
            </el-form-item>
            <el-form-item label="게시자" prop="wr_writer">
              <el-input v-model="ruleForm.wr_writer"></el-input>
            </el-form-item>
            <el-form-item label="내용" prop="wr_content">
              <el-input type="textarea" id="wr_content"  v-model="ruleForm.wr_content" >
              </el-input>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{ wr_id ? '수정' : '등록' }}</el-button>
              <el-button @click="resetForm('ruleForm')">목록 </el-button>
            </el-form-item>
          </el-form>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';
  import {countryList} from "@/service/countryService";

  export default {
    name: "NoticeCreate",
    components: {},
    mixins: [ VuxAlert,sessionStorage ],
    data() {
      return {
        wr_id : this.$route.params.wr_id,
        userInfo : this.getUserInfo(),
        c_idx : 1,
        l_idx: 1,
        category : [],
        ruleForm: {
          wr_subject: '',
          wr_content: '',
          wr_writer : ''
        },
        rules: {
          wr_subject: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
          ],
          wr_content: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
          ],
        },

      };
    },
    mounted() {
      this.getCountryCode();
      this.initSummernote();
      this.getCountryList();
      this.getNoticeDetail();
    },

    methods: {
      getCountryCode(){
        if(this.userInfo.g_idx === 2){
          this.c_idx = this.userInfo.c_idx;
          this.getLanguageCode();
        }
      },
      getLanguageCode() {
        let params = {
          cid: this.userInfo.c_idx
        }
        this.$api.$user.getLanguageCountryList(params).then(res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.l_idx = 1;
          }
        })
      },
      getCountryList(){
        this.$api.$user.getLanguage()
          .then(res => { // 로그인 api 통신 후 결과 처리
            this.category = res.Data.Result.List;
          });
      },
      initData() {
        this.ruleForm = {
          wr_subject: '',
          wr_content: '',
          wr_writer : ''
        }
        this.wr_id = this.$route.params.wr_id;
        this.category = [];
        this.c_idx = 1;
      },

      initSummernote() {
        let $this = this;
        $('#wr_content').summernote({
          height: 346,
          lang: 'ko',
          placeholder: '공지내용을 입력해주세요',
          disableResizeEditor: true,
          callbacks: {
            onChange: function() {
              $this.ruleForm.wr_content = $('#wr_content').summernote('code');
            },
            onImageUpload: function(files, editor, welEditable) {
              let formData = new FormData();
              formData.append('files', files[0]);
              $this.$api.$file.editorUpload(formData).then(res => {
                if(res.status === true){
                  let dom = document.createElement('img');
                  $(dom).attr('src', 'http://'+res.file_name);
                  $('#wr_content').summernote('insertNode', dom);
                }else{
                  status = res.reason;
                }
              })
            }
          }
        });
      },

      getNoticeDetail(){
        if(this.wr_id){
            const params = {  id : this.wr_id ,wr_type : 'post'}
            this.$api.$board.getNotice(params).then( res => res.Data.Result).then(res => {
              if(res.Info.Type === 1) {
                this.ruleForm = {
                  wr_subject: res.List[0].wr_subject,
                  wr_content: res.List[0].wr_content,
                  wr_writer : res.List[0].wr_writer
                }
                this.l_idx = res.List[0].l_idx
                $('#wr_content').summernote('code', util.htmlDecode(res.List[0].wr_content));
              }else{
                this.errorAlert(res.Info.reason);
              }

          })
        }
      },

      reFormDate (date) {
        //2019.02.15
        return this.$_.replace(date.split(' ')[0], /-/gi, '.')
      },

     submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.ruleForm;
            this.ruleForm.l_idx = this.l_idx;
            this.ruleForm.wr_id = this.wr_id;
            this.ruleForm.wr_type  = 'post';
            // this.ruleForm.b_type = ['country','writer'];
            this.ruleForm.b_type = ["writer"];
            if(this.ruleForm.wr_id){
              this.$api.$board.updateNotice(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1) {
                  this.updateAlert();
                }else{
                  this.errorAlert(res.Info.reason);
                }
              })
            }else{
              this.$api.$board.setNotice(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1) {
                  let alertParams = {'element' : this , 'editor' : true, 'id' : 'wr_content'};
                  this.saveAlert(alertParams);
                }else{
                  this.errorAlert(res.Info.reason);
                }
              })
            }
          } else {
            this.validateAlert();
            return false;
          }
        });
      },
      resetForm(formName) {
        window.history.back();
      }
    }
  }
</script>
